const RemoveCouponBtn = () => {
  const removeCouponBtn = document.querySelector(".woocommerce-remove-coupon");

  if (removeCouponBtn) {
    removeCouponBtn.innerHTML = "Remove coupon";
  }
}

export default RemoveCouponBtn;